/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import { DropDownList as i } from "@progress/kendo-react-dropdowns";
import { useLocalization as l } from "@progress/kendo-react-intl";
import { messages as c, columnMenuFilterAndLogic as r, columnMenuFilterOrLogic as m } from "../messages/index.mjs";
const g = [
  { text: r, logic: "and" },
  { text: m, logic: "or" }
], d = (e) => {
  const a = l(), o = (e.data || g).map((t) => ({
    ...t,
    text: a.toLanguageString(t.text, c[t.text])
  }));
  return /* @__PURE__ */ n.createElement(
    i,
    {
      onChange: e.onChange,
      className: "k-filter-and",
      textField: "text",
      ...e,
      data: o,
      value: o.find((t) => t.logic === e.value)
    }
  );
};
export {
  d as ColumnMenuFilterLogic
};
